import React from 'react';

function FetchLoading() {
    //assets
    const loading = "https://uploads.zibazi.tv/site/assets/teacher/icon/public/loading.gif"

    return (
        <div className="fixed flex-col z-[60] w-full top-0 left-0 h-screen flex justify-center items-center bg-[#00000088]">
            <img className='w-[5%]' src={loading} alt="load" />
        </div>
    )
}

export default FetchLoading